module.exports = __webpack_public_path__ + "static/img/dash-5.074cbd46.png";